import { createContext, useContext } from "react";
import { collection, orderBy, query } from "firebase/firestore";
import { db } from "../variables/values";
import { useCollectionData } from "react-firebase-hooks/firestore";

const CloudCtx = createContext({
  users: [],
  applications: [],
  lecturers: [],
  students: [],
  admins: [],
});

export const useCloudCtx = () => useContext(CloudCtx);

export const CloudCtxProvider = ({ children }) => {
  const uq = query(collection(db, "users"));
  const aq = query(collection(db, "applications"), orderBy("datetime", "asc"));

  const [users] = useCollectionData(uq, { idField: "id" });
  const [applications] = useCollectionData(aq, { idField: "id" });

  let lecturers = users && users.filter((ele) => ele.role === "lecturer");
  let students = users && users.filter((ele) => ele.role === "student");
  let admins = users && users.filter((ele) => ele.role === "admin");

  const context = {
    users: users,
    applications: applications,
    lecturers: lecturers,
    students: students,
    admins: admins,
  };

  return <CloudCtx.Provider value={context}>{children}</CloudCtx.Provider>;
};

export default CloudCtx;
